import {useCallService} from "../../services/callService";
import {PhoneHQGlyph} from 'ch3-ui-lib';
import {getFormatedPhoneNumber} from "../../utilis/msisdnUtilis.ts";
import {useSelector, useDispatch} from "react-redux";
import { navigateDialer, setCallFrom, setDialerHidden } from "../../store/features/calls/dialerSlice.ts";
import {useLazyGetStatusesQuery} from "../../store/features/Team/teamService.ts";
import {Phone} from "lucide-react";
import {makeMatrixCall} from "../../services/matrixCallService.ts";
import {selectTenant, selectUserId} from "../../store/features/Auth/authSlice.ts";
import type {ReactNode} from "react";


interface ClickToCallProps {
    contact?: any,
    label?: string
    msisdn: number
    noPrefix?: boolean
    className?: string
    icon?: boolean
    internal?: boolean
    showNumber?: boolean
    renderAs?: 'default' | 'button'
    size?: number
    tooltip?: string
    /** Button content for renderAs="button"; defaults to the phone icon. */
    children?: ReactNode
}

export const ClickToCall = ({ contact, msisdn,icon,className, internal = false, label,noPrefix, showNumber=true, renderAs = 'default', size = 32, tooltip, children }: ClickToCallProps) => {
    const { makeCall } = useCallService();
    const dispatch =  useDispatch();
    const tenantId = useSelector(selectTenant);
    const currentUserId = useSelector(selectUserId);
    const callState = useSelector((state: any) => state.dialer.callState);

    const [fetchStatuses] = useLazyGetStatusesQuery();

    const handleClick = async (e: any) => {
        if (callState !== 'IDLE') return;
        if (internal) {
            const res = await fetchStatuses({users: [contact?.userId]});
            if (res?.data?.[0]?.doNotDisturbUserStatus.enabled) {
                dispatch(navigateDialer(`/dnd-call`));
                dispatch(setDialerHidden(false));
                dispatch(setCallFrom(contact));

            } else {
                e.preventDefault();
                e.stopPropagation();
                if (callState !== 'IDLE') {
                    console.log('Call in progress, cannot make another call');
                    return;
                }

                // makeMatrixCall resolves the peer by user id and reuses the existing DM.
                await makeMatrixCall(contact,currentUserId, tenantId, dispatch);
            }

        } else {
            e.preventDefault();
            e.stopPropagation();
            if (callState !== 'IDLE') {
                console.log('Call in progress, cannot make another call');
                return;
            }
            makeCall({
                msisdn: msisdn.toString(),
                callTo: contact,
                isInternal: internal,
            });
        }
    }

    // Render as button (icon only)
    if (renderAs === 'button') {
        return (
            <button
                onClick={(e: any) => handleClick(e)}
                className={className}
                data-tooltip-left={tooltip}
                disabled={callState !== 'IDLE'}
            >
                {children ?? <Phone className="button p-1.5" size={size} />}
            </button>
        );
    }

    // Default rendering
    return (
        <div  onClick={(e:any)=> handleClick(e) } className={`flex items-center cursor-pointer ${className} `}>{showNumber &&  (label ? label : getFormatedPhoneNumber(msisdn, noPrefix))}
            <div>

                {icon && <PhoneHQGlyph name='call' size={20} className={` cursor-pointer ${(callState != 'IDLE' ) ? 'cursor-not-allowed text-ink-muted' : 'hover:text-brand-ink'}` + `${showNumber && ' text-brand-ink h-5 ' }`}/>}

            </div> </div>
    )
}
